import { neog, friends, himym, suits } from "../assets";

export const categories = [
  {
    categoryName: "NeoG",
    categoryNumber: 1,
    description: "Take this Quiz to test your knowledge about Neog Camp",
    image: neog,
  },
  {
    categoryName: "F.R.I.E.N.D.S",
    categoryNumber: 0,
    description:
      "Think you're an expert on all things Central Perk? Take this Friends quiz to prove whether or not you're a true fan.",
    image: friends,
  },
  {
    categoryName: "How I Met Your Mother",
    categoryNumber: 2,
    description:
      "This Is The Hardest How I Met Your Mother Knowledge Test You'll Ever Take",
    image: himym,
  },
  {
    categoryName: "Suits",
    categoryNumber: 3,
    description:
      "How much do you know about USA's Suits? Take our quiz and find out now!",
    image: suits,
  },
];
